document.addEventListener("DOMContentLoaded", function () {
  const ctaButton = document.getElementById("privacy-request-cta");
  const requestForm = document.getElementById("privacy-request-form");

  if (ctaButton && requestForm) {
    ctaButton.addEventListener("click", function (event) {
      event.preventDefault(); // Prevents the page from reloading or jumping unexpectedly
      
      // Makes the HubSpot form container visible
      requestForm.style.display = "block"; 
      
      // Optional: Smoothly scroll down to the form so the user sees it
      requestForm.scrollIntoView({ behavior: "smooth" });
    });
  }
});